"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import UiDialog from "@/components/dialog/UiDialog.vue";
let ShopAccountTipDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.amount = 0;
    this.flag = false;
    this.timer = null;
    // 倒计时
    this.countdown = 3;
  }
  open(amount) {
    return __async(this, null, function* () {
      this.amount = amount;
      this.showAmountTipDialog.show();
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.flag = true;
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1e3);
    });
  }
  confirm() {
    this.showAmountTipDialog.hide();
    this.countdown = 3;
    this.flag = false;
    this.$emit("confirm", true);
  }
  close() {
    this.showAmountTipDialog.hide();
    this.countdown = 3;
    this.flag = false;
    this.$emit("confirm", false);
  }
};
__decorateClass([
  Ref("show-amount-tip-dialog")
], ShopAccountTipDialog.prototype, "showAmountTipDialog", 2);
ShopAccountTipDialog = __decorateClass([
  Component({
    components: { UiDialog }
  })
], ShopAccountTipDialog);
export {
  ShopAccountTipDialog as default
};
